<template>
    <div>
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <div class="section-header">
                {{ $t('pos.multi_accounts_detail') }}
            </div>
            <kt-datatable ref="datatableOwnerProps" v-bind="datatableOwnerProps" ></kt-datatable>
        </div>
        <kt-button
                class="m-2"
                size="md"
                @click="addParent"
                variant="success"
                type="submit"
                v-bind:wide="true"
                id="addParent"
        >
            {{ $t('btn.add') }}
        </kt-button>
        <div v-for="(parent, index) in form.parent" v-bind:key="index">
            <kt-form-section v-show="parent.show_child" :id="index">
                <div class="container p-3 pt-5 my-4 border in-border-header"
                     style="border: solid 2px #5e5e5e !important;">
                    <div class="section-header">
                        {{ $t('pos.account_owner_detail') }}
                    </div>
                    <form v-if="parent.get_customer_form" @submit.prevent="getCustomer(index)"
                          :id="'get_customer_by_code'+index">
                        <div class="container p-3 pt-5 my-4 border in-border-header">
                            <kt-form-section is_first>
                                <div class="section-header">
                                    {{ $t('pos.get_account_owner_by_code') }}
                                </div>
                                <kt-row>
                                    <kt-col lg="3" md="3" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="customer_type">
                                                {{ $t('pos.customer_type') }}
                                            </kt-form-label>
                                            <select
                                                    id="customer_type"
                                                    class="form-control kt-selectpicker"
                                                    name="customer_type"
                                                    v-model="parent.customer_type"
                                            >
                                                <option
                                                        v-for="(user_type, index) in user_types"
                                                        :key="index"
                                                        :value="user_type">

                                                    {{ user_types_str.get(user_type) }}
                                                </option>
                                            </select>
                                            <div class="my-4">
                                            </div>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="parent.customer_type==2" id="legal_code" lg="6"
                                            md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="customer_code">
                                                {{ $t('label.national_legal_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="customer_code"
                                                    name="customer_code"
                                                    v-model="parent.customer_code"
                                            >
                                            </kt-form-control>
                                        </kt-form-group>

                                    </kt-col>
                                    <kt-col id="national_code" v-if="parent.customer_type==1" lg="6"
                                            md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="customer_code">
                                                {{ $t('label.national_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="customer_code1"
                                                    name="customer_code"
                                                    v-model="parent.customer_code"
                                            >
                                            </kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="parent.customer_type == 2 || parent.customer_type==1 " lg="3"
                                            md="3"
                                            xs="6">
                                        <kt-form-action class="mt-4">
                                            <kt-button
                                                    class="m-2"
                                                    size="md"
                                                    variant="success"
                                                    type="submit"
                                                    v-bind:wide="true"
                                                    :id="'btn_inquiry'+index"
                                            >
                                                {{ $t('pos.btn_inquiry') }}
                                            </kt-button>
                                        </kt-form-action>
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </div>
                    </form>

                    <div v-if="parent.show_detail" class="container p-3 pt-5 my-4 border in-border-header">
                        <form :id="'customer_detail'+index">
                            <kt-form-section is_first>
                                <div class="section-header">
                                    {{ $t('pos.account_owner_information') }}
                                </div>
                                <kt-row>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label v-show="parent.customer_detail.CustomerTypeID == 1327"
                                                           for="NationalCode">
                                                {{ $t('label.national_code') }}
                                            </kt-form-label>
                                            <kt-form-label v-show="parent.customer_detail.CustomerTypeID == 1328"
                                                           for="NationalCode">
                                                {{ $t('pos.ceo_national_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    :disabled="parent.customer_detail.CustomerTypeID == 1327"
                                                    type="number"
                                                    dir="ltr"
                                                    id="NationalCode"
                                                    name="NationalCode"
                                                    v-model="parent.customer_detail.NationalCode"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="!parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="BCID">
                                                {{ $t('label.birth_crtfct_number') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="BCID"
                                                    name="BCID"
                                                    v-model="parent.customer_detail.BCID"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="BirthDate">
                                                {{ $t('label.birth_date') }}
                                            </kt-form-label>
                                            <datePicker
                                                    format="YYYY-MM-DD"
                                                    display-format="jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="BirthDate"
                                                    name="BirthDate"
                                                    v-model="parent.customer_detail.BirthDate" type="date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="CustomerID">
                                                {{ $t('pos.customer_id') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    disabled
                                                    type="number"
                                                    dir="ltr"
                                                    id="CustomerID"
                                                    name="CustomerID"
                                                    v-model="parent.customer_detail.CustomerID"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="GenderID">
                                                {{ $t('label.gender') }}
                                            </kt-form-label>
                                            <select
                                                    id="GenderID"
                                                    name="GenderID"
                                                    v-model="parent.customer_detail.GenderID"
                                                    class="form-control kt-selectpicker"
                                            >
                                                <option
                                                        v-for="(item,index) in constants.Gender" :value="index">
                                                    {{ item }}
                                                </option>
                                            </select>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="Mobile">
                                                {{ $t('pos.mobile') }}
                                            </kt-form-label>

                                            <kt-form-control
                                                    dir="ltr"
                                                    :id="'Mobile'+ index"
                                                    name="Mobile"
                                                    v-model="parent.customer_detail.Mobile"
                                                    class="form-control"
                                            ></kt-form-control>
                                            <kt-form-label style="margin-top: 5px;font-size: 9px;color: red">
                                                {{ $t('pos.mobile_notification') }}
                                            </kt-form-label>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="FirstName">
                                                {{ $t('label.first_name_fa') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="FirstName"
                                                    name="FirstName"
                                                    v-model="parent.customer_detail.FirstName"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="LastName">
                                                {{ $t('label.last_name_fa') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="LastName"
                                                    name="LastName"
                                                    v-model="parent.customer_detail.LastName"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="FatherName">
                                                {{ $t('label.father_name_fa') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="FatherName"
                                                    name="FatherName"
                                                    v-model="parent.customer_detail.FatherName"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.customer_detail.CustomerTypeID == 1328" lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="CompanyName">
                                                {{ $t('label.com_name_fa') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="CompanyName"
                                                    name="CompanyName"
                                                    v-model="parent.customer_detail.CompanyName"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col lg="4" md="6" xs="12"
                                            v-show="parent.customer_detail.CustomerTypeID == 1328">
                                        <kt-form-group>
                                            <kt-form-label for="CompanyFoundationDate">
                                                {{ $t('label.com_register_date') }}
                                            </kt-form-label>
                                            <datePicker
                                                    format="YYYY-MM-DD"
                                                    display-format="jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="CompanyFoundationDate"
                                                    name="CompanyFoundationDate"
                                                    v-model="parent.customer_detail.CompanyFoundationDate"
                                                    type="date"/>
                                        </kt-form-group>
                                    </kt-col>

                                    <kt-col v-show="parent.customer_detail.CustomerTypeID == 1328" lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="CompanyRegisterNo">
                                                {{ $t('pos.com_register_no') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="CompanyRegisterNo"
                                                    name="CompanyRegisterNo"
                                                    v-model="parent.customer_detail.CompanyRegisterNo"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.customer_detail.CustomerTypeID == 1328" lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="CompanyNameEn">
                                                {{ $t('label.com_name_en') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    id="CompanyNameEn"
                                                    name="CompanyNameEn"
                                                    v-model="parent.customer_detail.CompanyNameEn"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.customer_detail.CustomerTypeID == 1328" lg="4" md="6"
                                            xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="CompanyCode">
                                                {{ $t('label.national_legal_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    disabled
                                                    type="number"
                                                    dir="ltr"
                                                    id="CompanyCode"
                                                    name="CompanyCode"
                                                    v-model="parent.customer_detail.CompanyCode"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="Country">
                                                {{ $t('label.country_flag') }}
                                            </kt-form-label>
                                            <select
                                                    id="Country"
                                                    name="Country"
                                                    v-model="parent.customer_detail.Country"
                                                    class="form-control  kt-selectpicker"
                                            >
                                                <option
                                                        v-for="country in constants.Country"
                                                        :value="country.CountryCode">
                                                    {{ country.CountryName }}
                                                </option>
                                            </select>
                                            <div class="my-4">
                                            </div>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="ForeignersPervasiveCode">
                                                {{ $t('pos.foreign_pervasive_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="ForeignersPervasiveCode"
                                                    name="ForeignersPervasiveCode"
                                                    v-model="parent.customer_detail.ForeignersPervasiveCode"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="PassportCode">
                                                {{ $t('pos.passport_code') }}
                                            </kt-form-label>
                                            <kt-form-control
                                                    type="number"
                                                    dir="ltr"
                                                    id="PassportCode"
                                                    name="PassportCode"
                                                    v-model="parent.customer_detail.PassportCode"
                                                    class="form-control"
                                            ></kt-form-control>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-show="parent.is_foreign" lg="4" md="6" xs="12">
                                        <kt-form-group>
                                            <kt-form-label for="PassportCreditDate">
                                                {{ $t('pos.passport_credit_date') }}
                                            </kt-form-label>
                                            <datePicker
                                                    format="YYYY-MM-DD"
                                                    display-format="jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="PassportCreditDate"
                                                    name="PassportCreditDate"
                                                    v-model="parent.customer_detail.PassportCreditDate"
                                                    type="date"/>
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col v-if="parent.customer_detail.CustomerTypeID == 1327" lg="12" md="12"
                                            xs="12">
                                        <kt-form-group>

                                            <div class="custom-control custom-switch">
                                                <input type="checkbox" class="custom-control-input"
                                                       :id="'is_foreign'+index"
                                                       name="is_foreign"
                                                       v-model="parent.is_foreign"
                                                >
                                                <label class="custom-control-label"
                                                       :for="'is_foreign'+index">{{
                                                        $t('pos.is_foreign')
                                                    }}</label>
                                            </div>
                                        </kt-form-group>
                                    </kt-col>
                                </kt-row>
                                <div v-if="parent.customer_detail.show_register_btn"
                                     class="container p-3 pt-5 my-4 border in-border-header">
                                    <kt-form-section is_first>
                                        <div class="section-header">
                                            {{ $t('pos.documents') }}
                                        </div>
                                        <kt-row v-if="!parent.is_foreign">
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label
                                                                v-if="parent.customer_detail.CustomerTypeID == 1327"
                                                                for="national_card_img">
                                                            {{ $t('pos.document.national_card') }}
                                                        </kt-form-label>
                                                        <kt-form-label
                                                                v-if="parent.customer_detail.CustomerTypeID == 1328"
                                                                for="national_card_img">
                                                            {{
                                                                $t('pos.document.national_card')
                                                            }}{{ ' ' + $t('pos.ceo') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'national_card_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'national_card_img'+index"
                                                                name="national_card_img"
                                                                class="custom-file-upload"
                                                               accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.national_card_img">
                                                    <img
                                                            :src="parent.images_url.national_card_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label
                                                                v-if="parent.customer_detail.CustomerTypeID == 1327"
                                                                for="birth_certificate_card_img">
                                                            {{ $t('pos.document.birth_certificate_card') }}
                                                        </kt-form-label>
                                                        <kt-form-label
                                                                v-if="parent.customer_detail.CustomerTypeID == 1328"
                                                                for="birth_certificate_card_img">
                                                            {{
                                                                $t('pos.document.birth_certificate_card')
                                                            }}{{ ' ' + $t('pos.ceo') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'birth_certificate_card_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'birth_certificate_card_img'+index"
                                                                name="birth_certificate_card_img"
                                                                class="custom-file-upload"
                                                               accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.birth_certificate_card_img">
                                                    <img
                                                            :src="parent.images_url.birth_certificate_card_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label
                                                                v-if="parent.customer_detail.CustomerTypeID == 1327"
                                                                for="national_card_behind_img">
                                                            {{ $t('pos.document.national_card_behind') }}
                                                        </kt-form-label>
                                                        <kt-form-label
                                                                v-if="parent.customer_detail.CustomerTypeID == 1328"
                                                                for="national_card_behind_img">
                                                            {{
                                                                $t('pos.document.national_card_behind')
                                                            }}{{ ' ' + $t('pos.ceo') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'national_card_behind_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'national_card_behind_img'+index"
                                                                name="national_card_behind_img"
                                                                class="custom-file-upload"
                                                               accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.national_card_behind_img">
                                                    <img
                                                            :src="parent.images_url.national_card_behind_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row v-if="parent.customer_detail.CustomerTypeID==1328"
                                                style="margin-top: 35px">
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label for="last_newspaper_img">
                                                            {{ $t('pos.document.last_newspaper') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'last_newspaper_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'last_newspaper_img'+index"
                                                                name="last_newspaper_img"
                                                                class="custom-file-upload"
                                                               accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.last_newspaper_img">
                                                    <img
                                                            :src="parent.images_url.last_newspaper_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label for="statute_pages_img">
                                                            {{ $t('pos.document.statute_pages') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'statute_pages_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processStatuteFile($event,index)"
                                                                type="file"
                                                                :id="'statute_pages_img'+index"
                                                                name="statute_pages_img"
                                                                class="custom-file-upload"
                                                                accept=".jpg,.jpeg,image/png"
                                                                multiple
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.statute_pages_img">
                                                    <img v-for="image in parent.images_url.statute_pages_img"
                                                         :src="image"
                                                         :alt="image.alt"
                                                         style="width:150px; height:100px;padding-bottom: 5px"
                                                         class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label for="foundation_img">
                                                            {{ $t('pos.document.foundation_image') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'foundation_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'foundation_img'+index"
                                                                name="foundation_img"
                                                                class="custom-file-upload"
                                                                accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.foundation_img">
                                                    <img
                                                            :src="parent.images_url.foundation_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                        </kt-row>
                                        <kt-row v-show="parent.is_foreign" style="margin-top: 35px">
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label for="passport_img">
                                                            {{ $t('pos.document.passport') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'passport_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'passport_img'+index"
                                                                name="passport_img"
                                                                class="custom-file-upload"
                                                                accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12" v-show="parent.images_url.passport_img">
                                                    <img
                                                            :src="parent.images_url.passport_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label for="amyesh_card_img">
                                                            {{ $t('pos.document.amyesh_card') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'amayesh_card_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'amayesh_card_img'+index"
                                                                name="amyesh_card_img"
                                                                class="custom-file-upload"
                                                                accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.amayesh_card_img">
                                                    <img
                                                            :src="parent.images_url.amayesh_card_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                            <kt-col lg="4" md="4" xs="12">
                                                <kt-col lg="12" md="12" xs="12">
                                                    <kt-form-group>
                                                        <kt-form-label for="work_permit_img">
                                                            {{ $t('pos.document.work_permit') }}
                                                        </kt-form-label>
                                                        <kt-form-label :for="'work_permit_img'+index"
                                                                       class="d-block btn btn-secondary btn-wide label-file">
                                                            <kt-icon type="fa" name="paperclip"></kt-icon>
                                                            {{ $t('pos.click_me') }}
                                                        </kt-form-label>
                                                        <input
                                                                @change="processFile($event,index)"
                                                                type="file"
                                                                :id="'work_permit_img'+index"
                                                                name="work_permit_img"
                                                                class="custom-file-upload"
                                                                accept=".jpg,.jpeg,image/png"
                                                        />
                                                    </kt-form-group>
                                                </kt-col>
                                                <kt-col lg="12" md="12" xs="12"
                                                        v-show="parent.images_url.work_permit_img">
                                                    <img
                                                            :src="parent.images_url.work_permit_img"
                                                            style="width:150px; height:100px" class="d-block m-auto">
                                                </kt-col>
                                                <hr>
                                            </kt-col>
                                        </kt-row>

                                    </kt-form-section>
                                </div>

                            </kt-form-section>
                        </form>
                    </div>
                    <div>
                        <form v-if="parent.show_detail" :id="'account_detail'+index">
                            <kt-form-section>
                                <div class="container p-3 pt-5 my-4 border in-border-header">
                                    <div class="section-header">
                                        {{ $t('pos.account_detail') }}
                                    </div>
                                    <kt-row style="padding-top: 35px">
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="BankID">
                                                    {{ $t('pos.bank') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        id="BankID"
                                                        name="BankID"
                                                        v-model="parent.BankID"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="BranchCode">
                                                    {{ $t('pos.branch_code') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        dir="ltr"
                                                        type="number"
                                                        id="BranchCode"
                                                        name="BranchCode"
                                                        v-model="parent.BranchCode"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                    <kt-row>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="AccountNumber">
                                                    {{ $t('label.account_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        type="number"
                                                        dir="ltr"
                                                        id="AccountNumber"
                                                        name="AccountNumber"
                                                        v-model="parent.AccountNumber"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="AccountShabaCode">
                                                    {{ $t('label.sheba_number') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        style="direction: ltr"
                                                        id="AccountShabaCode"
                                                        name="AccountShabaCode"
                                                        v-model="parent.AccountShabaCode"
                                                        class="form-control transfers_destination_number"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                    <kt-row>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="SharingPercent">
                                                    {{ $t('allotment.percent') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        type="number"
                                                        dir="ltr"
                                                        id="SharingPercent"
                                                        name="SharingPercent"
                                                        v-model="parent.SharingPercent"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                        <kt-col lg="6" md="6" xs="12">
                                            <kt-form-group>
                                                <kt-form-label for="customer_id">
                                                    {{ $t('pos.customer_id') }}
                                                </kt-form-label>
                                                <kt-form-control
                                                        disabled
                                                        type="number"
                                                        dir="ltr"
                                                        id="customer_id"
                                                        name="customer_id"
                                                        v-model="parent.CustomerID"
                                                        class="form-control"
                                                ></kt-form-control>
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-row>
                                </div>

                            </kt-form-section>
                        </form>
                    </div>
                    <kt-button
                            class="m-2"
                            size="md"
                            dir="ltr"
                            @click="remove(index)"
                            variant="danger"
                            type="delete"
                            v-bind:wide="true"
                            id="remove"
                    >
                        {{ $t('btn.delete') }}
                    </kt-button>
                    <kt-button v-if="parent.show_detail" style="position: relative;right:75%"
                               class="m-2"
                               size="md"
                               dir="rtl"
                               @click="setAccount(index)"
                               variant="success"
                               type="submit"
                               v-bind:wide="true"
                               id="remove"
                    >
                        {{ $t('btn.register') }}
                    </kt-button>
                </div>
            </kt-form-section>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import Inputmask from "inputmask";
import {userTypes, userTypesStr} from '@/constants/userTypes';
import {KTApp} from '@/plugins/core/app'
import {posService} from '@/common/api.service'
import toastr from "toastr";
import MultiAccountOwnerColumns from "../datatable/Multi_Account_owners";
import {ActionsMultiAccountColumn} from "./index";

export default {
    data() {
        return {
            form: {
                parent: [],
            },
            customer_detail: {},
            show_detail: false,
            user_types: userTypes,
            user_types_str: userTypesStr,
            constants: {}
        }
    },
    props: {
        wizard: {
            type :Object
        } ,
        form_data: {
            type :Object
        } ,
        reloadDataTable: {
            type:Function,
        }

    },
    methods: {
        addParent: function () {
            this.form.parent.push({
                BankID: '',
                BranchCode: '',
                AccountNumber: '',
                AccountShabaCode: '',
                SharingPercent: '',
                CustomerID: '',
                customer_type: '',
                customer_code: '',
                customer_detail: '',
                show_detail: false,
                show_child: true,
                is_foreign: false,
                get_customer_form: true,
                images_url: {
                    national_card_img: null,
                    birth_certificate_card_img: null,
                    national_card_behind_img: null,
                    last_newspaper_img: null,
                    statute_pages_img: null,
                    foundation_img: null,
                    passport_img: null,
                    amyesh_card_img: null,
                    work_permit_img: null,
                },
                national_card_img: null,
                birth_certificate_card_img: null,
                national_card_behind_img: null,
                last_newspaper_img: null,
                statute_pages_img: [],
                foundation_img: null,
                passport_img: null,
                amayesh_card_img: null,
                work_permit_img: null,

            });
            this.afterDispatch()
            setTimeout(() => {
                this.initShebaMask()
            }, 500)
        },
        remove: function (index) {
            this.form.parent.splice(index, 1)
        },
        setAccount(index) {
            this.$store.commit('pos/addMultiAccountOwner', this.form.parent[index])
            if (this.$refs.datatable1.KTDatatable) {
                this.$refs.datatable1.reload()
            }
           return true;
            let form = $('#customer_detail' + index)
            let btn = $('#register' + index)
            form.validate({
                lang: 'fa',
                rules: {
                    BCID: {
                        required: () => {
                            if (!this.form.parent[index].is_foreign) return true; else return false
                        }
                    },

                    BirthDate: {
                        required: true,
                    },
                    CompanyCode: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.CustomerTypeID == 1328) return true; else return false
                        }
                    },

                    CompanyFoundationDate: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.CustomerTypeID == 1328) return true; else return false
                        }
                    },
                    PassportCreditDate: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },

                    CompanyName: {
                        required: () => {
                            if (this.form.parent[index].customer_detail.CustomerTypeID == 1328) return true; else return false
                        }
                    },
                    CustomerTypeID: {
                        required: true
                    },

                    GenderID: {
                        required: true,
                    },
                    LastName: {
                        required: true
                    },

                    FatherName: {
                        required: true,
                    },
                    FirstName: {
                        required: true
                    },

                    ForeignersPervasiveCode: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    PassportCode: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    Country: {
                        required: () => {
                            if (this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    Mobile: {
                        required: true,
                        digits: 11
                    },

                    NationalCode: {
                        required: true,
                    },
                    national_card_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && !this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    birth_certificate_card_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && !this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    national_card_behind_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && !this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    passport_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    amayesh_card_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && this.form.parent[index].is_foreign) return true; else return false
                        }
                    },

                    work_permit_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && this.form.parent[index].is_foreign) return true; else return false
                        }
                    },
                    last_newspaper_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && this.form.parent[index].customer_detail.CustomerTypeID === 1328) return true; else return false
                        }
                    },
                    statute_pages_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && this.form.parent[index].customer_detail.CustomerTypeID == 1328) return true; else return false
                        }
                    },
                    foundation_img: {
                        required: () => {
                            if (!this.form.parent[index].CustomerID && this.form.parent[index].customer_detail.CustomerTypeID == 1328) return true; else return false
                        }
                    },
                }
            });
            if (!form.valid()) {
                return
            }

            KTApp.progress(btn)

            this.form.parent[index].customer_detail.ISForeignNationals = this.form.parent[index].is_foreign;

            let stakeholder = structuredClone(this.form.parent[index]);
            delete stakeholder.images_url;
            delete stakeholder.show_detail;
            delete stakeholder.show_child;
            delete stakeholder.is_foreign;
            delete stakeholder.get_customer_form;
            delete stakeholder.index;
            delete stakeholder.IsActive;
            delete stakeholder.customer_detail;

            let stakeholder_data = {
                ...this.form.parent[index].customer_detail, ...stakeholder
            }
            posService.addStakeholder(stakeholder_data).then(response => {
                this.form.parent[index].stakeholder_id = response.data.data
                this.form.parent[index].customer_detail.Name = this.form.parent[index].customer_detail.FirstName
                       + ' ' + this.form.parent[index].customer_detail.LastName

                this.$store.commit('pos/addMultiAccountOwner', this.form.parent[index])
                this.reloadDataTable()
                this.form.parent[index].show_child = false
            }).catch(({response}) => {
                this.toastr.error(response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })

        },
        initShebaMask() {
            setTimeout(() => {
                Inputmask("IR 9999-9999-9999-9999-9999-9999")
                        .mask(document.querySelectorAll('.transfers_destination_number'))
            }, 500)
        }
        ,
        processFile(e, index) {
            const name = e.target.name;
            let file = e.target.files[0];
            this.form.parent[index].images_url[name] = URL.createObjectURL(file);
            this.form.parent[index][name] = file;
        },
        processStatuteFile(e, index) {
            this.form.parent[index].images_url.statute_pages_img = []
            for (let i = 0; i < e.target.files.length; i++) {
                let file = e.target.files[i];
                this.form.parent[index].images_url.statute_pages_img[i] = URL.createObjectURL(file);
                this.form.parent[index].statute_pages_img[i] = file;
            }
        },
        initMobileMask(index) {
            setTimeout(() => {
                document.getElementById('Mobile' + index) && Inputmask('09999999999')
                        .mask(document.getElementById('Mobile' + index))
            }, 500)
        }
        ,
        getCustomer(index) {

            this.$store.commit('pos/addMultiAccountOwner', {farid:22})
           return  this.$refs.datatable1.reload()
            let form = $('#get_customer_by_code' + index)
            let btn = $('#btn_inquiry' + index)
            this.form.parent[index].show_detail = false
            form.validate({
                lang: 'fa',
                rules: {
                    customer_type: {
                        required: true
                    },
                    customer_code: {
                        required: true,
                        digits: true,
                        minlength: () => {
                            if (this.form.parent[index].customer_type == this.user_types.REAL) return 10; else return 11;
                        },
                        maxlength: () => {
                            if (this.form.parent[index].customer_type == this.user_types.REAL) return 10; else return 11;
                        }
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            let multi_account = this.$store.state.pos.form_data['bank_account_detail']['multi_account_details']
            let multi_acc_index = multi_account.length
            if (this.form_data.customer_detail.CustomerTypeID === 1327 &&
                    this.form.parent[index].customer_code === this.form_data.customer_detail.NationalCode ||
                    this.form_data.customer_detail.CustomerTypeID === 1328 &&
                    this.form.parent[index].customer_code === this.form_data.customer_detail.CompanyCode) {
                return this.toastr.error(i18n.t('message.duplicate_customer_code'))
            }
            if (multi_acc_index > 0) {
                for (let i = 0; i < multi_acc_index; i++) {
                    if (this.form.parent[index].customer_code == multi_account[i].customer_detail.CustomerCode)
                        return this.toastr.error(i18n.t('message.duplicate_customer_code'))
                }
            }
            this.form.parent[index].customer_detail = {}
            this.form.parent[index].is_foreign = false
            KTApp.progress(btn)
            let form_data = {
                customer_type: this.form.parent[index].customer_type,
                customer_code: this.form.parent[index].customer_code
            };
            posService.getCustomerByCode(form_data).then(response => {
                this.form.parent[index].customer_detail = response.data.data
                this.form.parent[index].CustomerID = response.data.data.CustomerID
                if (!this.form.parent[index].customer_detail.GenderID) this.form.parent[index].customer_detail.GenderID = 1330
                if (this.form.parent[index].customer_detail.ISForeignNationals == 'True') {
                    this.form.parent[index].is_foreign = true;
                } else this.form.parent[index].is_foreign = false
                if (this.form.parent[index].customer_detail.CustomerID == '') this.form.parent[index].customer_detail.show_register_btn = true
                KTApp.unprogress(btn)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.form.parent[index].customer_detail.show_register_btn = true
                this.form.parent[index].is_foreign = false
                if (this.form.parent[index].customer_type === this.user_types.LEGAL) {
                    this.form.parent[index].customer_detail.CustomerTypeID = 1328
                    this.form.parent[index].customer_detail.CustomerType = userTypesStr.get(userTypes.LEGAL)
                    this.form.parent[index].customer_detail.CompanyCode = this.form.parent[index].customer_code
                } else {
                    this.form.parent[index].customer_detail.CustomerTypeID = 1327
                    this.form.parent[index].customer_detail.CustomerCode = this.form.parent[index].customer_code
                    this.form.parent[index].customer_detail.CustomerType = userTypesStr.get(userTypes.REAL)
                    this.form.parent[index].customer_detail.NationalCode = this.form.parent[index].customer_code
                }
                this.showMsg(form, 'danger', response.data.message)

            }).finally(() => {
                this.form.parent[index].show_detail = true
                this.form.parent[index].get_customer_form = false
                KTApp.unprogress(btn)
                this.afterDispatch()
                this.initMobileMask(index)
                this.initShebaMask()
            })

        }
        ,
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker').selectpicker({
                    size: 6,
                    liveSearch: false,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });
            }, 500);
        }
    },

    mounted() {
        this.constants = this.$store.state.pos.constants
        this.afterDispatch()
        this.initShebaMask();
    },
    computed: {
        datatableOwnerProps() {
            return {
                id: "multi_account_owner_datatable",
                data: {
                    type: "local",
                    source: {
                        read: {
                            map: () => {
                                return this.$store.state.pos.form_data.bank_account_detail.multi_account_owners
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: MultiAccountOwnerColumns,
                actions: ActionsMultiAccountColumn,
            };
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
}
</script>

<style>
#app {
    text-align: right;
    color: #2c3e50;
    margin-top: 60px;
}

a,
button {
    color: #4fc08d;
}

button {
    background: none;
    border: solid 1px;
    border-radius: 2em;
    padding: 0.75em 2em;
}

.form-repeater {
    line-height: 20px;
    margin-bottom: 20px;
}

.form {
    padding: 20px;
    border: 1px solid #000;
    border-radius: 20px;
}
</style>